<!-- Web-only application -->
<div>
  @if (isTenantPresale) {
    <div class="bg-indigo-500 text-white p-2 md:py-3 md:px-5 text-xs flex align-items-center">
      <i class="fa fa-building mr-2 md:mr-3"></i>
      <strong>{{ 'TENANT.TENANT_PRESALES' | translate }}</strong>
    </div>
  }
  @if (showStaffNotificationBanner.value && showNotification.value) {
    <div
      class="bg-yellow-100 text-yellow-900 py-2 px-2 md:px-5 text-xs flex align-items-center justify-content-between">
      <div class="flex align-items-center mr-3">
        <i class="fa fa-bell"></i>
        <strong class="mx-2 md:mx-3">{{ 'STAFF.STAFF_PREFERENCE.NOTI_INFO' | translate }}</strong>
        <p-button [label]="'STAFF.STAFF_PREFERENCE.BTN_ENABLE' | translate" (onClick)="ConfigureNotification()"
        styleClass="text-xs p-button-outlined bg-yellow-100 border-yellow-900 text-yellow-900 hover:bg-yellow-900 hover:text-white line-height-1 white-space-nowrap" />
      </div>
      <i class="fa fa-times cursor-pointer text-lg" (click)="SetHideNotification(true)"></i>
    </div>
  }
  @if (isAdminLayout.getValue()) {
    <div class="min-h-screen flex surface-100 text-sm">
      <app-sidebar />
      <div class="min-h-screen flex flex-column relative flex-auto overflow-x-hidden main-content-wrapper text-900">
        <app-header [tenantList]="getAccessTenantList$ | async" />
        <router-outlet />
        <!-- <app-footer></app-footer> -->
      </div>
    </div>
  } @else {
    <router-outlet /> <!-- Content for non-admin pages like login -->
  }
  <!-- <router-outlet></router-outlet> -->
  <p-confirmDialog header="Confirmation" [style]="{width: '400px'}" styleClass="z-2104"
    [baseZIndex]="10000" />
</div>

<p-toast key="main" [autoZIndex]="true" position="top-right" [breakpoints]="{ '767px': { width: '100%', left: '0' } }" />
<p-toast key="top_center_main" [autoZIndex]="true" position="top-center" [breakpoints]="{ '767px': { width: '100%', left: '0' } }" />

<p-toast key="main_template" [autoZIndex]="true" position="top-right" [breakpoints]="{ '767px': { width: '100%', left: '0' } }">
  <ng-template let-message pTemplate="message">
    <strong>{{ 'STAFF_SCHEDULE.MSG.STAFF_UNAVAILABLE_MSG2' | translate : { name : message.data.name } }}
      <a [routerLink]="['/admin/staff-availability',message.data.id]">{{ 'STAFF_SCHEDULE.MSG.MANAGE_AVAIL' | translate }}
      </a>
      {{ 'STAFF_SCHEDULE.MSG.STAFF_UNAVAILABLE_MSG_1' | translate }}
    </strong>
  </ng-template>
</p-toast>

@if (splashScreen.getSpinner | async) {
  <div
    class="fixed left-0 top-0 z-2104 flex align-items-center surface-0-alpha-70 justify-content-center w-full h-full">
    <p-progressSpinner />
  </div>
}

@if (showStaffPreferenceSidebar.value) {
  <staff-preferences [showClientSidebar]="showStaffPreferenceSidebar.value"
    [activeStaffId]="selectedStaffId" (closeSidebar)="closeStaffNotificationBanner($event)" />
}